<template>
    <div class="bee_pc_invite_base_layout">

        <!-- <div class="pc_header">
            <div class="logo_header">
                <div class="logo_ic" @click.stop="pcBack()">
                </div>
            </div>
        </div> -->



        <div class="pc_content_layout">

            <div class="pc_back_layout" @click="pcBack">
                <div class="ic_back">
                </div>
                <div class="back_home_txt">
                    Home
                </div>
                <div class="ic_back_right"></div>

                <div class="back_invite_txt">
                    Friends
                </div>
            </div>

            <div class="content_pc_layout">


                <div class="invite_info_layout">

                    <div class="pc_invite_info_layout">

                        <div class="pc_invite_title_txt">Bring pal, earn more!</div>

                        <div class="pc_info_line"></div>

                        <div class="pc_invite_info_txt">For each new friend, you'll receive <span
                                class="pc_red_xp_num">{{
                                    normalOnceRewardAmount
                                }}xp</span> plus <span class="pc_red_xp_num">{{ dividendYield }}%</span> of all their
                            XP
                            earnings
                        </div>


                    </div>

                    <div>
                        <div class="img_ipx" />
                    </div>

                </div>



                <div class="pc_invite_content_layout">



                    <div class="rf_title_bonus">Invite friends to get bonus </div>



                    <div class="pc_xp_info_layout">

                        <div class="pc_item_for_xp">
                            <div class="pc_ic_logo"></div>
                            <div class="pc_for_txt">For you</div>
                            <div class="pc_for_xp_txt">
                                {{ normalOnceRewardAmount }}
                            </div>

                        </div>

                        <div class="pc_item_for_xp">
                            <div class="pc_ic_logo"></div>
                            <div class="pc_for_txt">For your friend</div>
                            <div class="pc_for_xp_txt">
                                {{ superOnceReferralAmount }}
                            </div>

                        </div>

                    </div>



                    <div class="pc_xp_info_layout">

                        <div class="pc_item_for_btn" @click="share">
                            Invite a Friend
                        </div>

                        <div class="pc_item_for_btn" @click="copyToPCClipboard">
                            Copy
                        </div>

                    </div>


                    <div class="rf_title_bonus">Friends List ({{ friendsAmount }})</div>




                    <div class="rf_list_layout">


                        <div class="rf_reward_layout">
                            <div class="pc_total_txt">Total amount:</div>
                            <div class="mini_pc_ic_logo"></div>

                            <div class="pc_total_num">{{ xpCanClaimAmount }}</div>


                            <div class="css_margin_left">
                                <div v-if="isClaim" class="submit_load">
                                    <div class="loading_logo"></div>
                                </div>

                                <div v-else :class="xpCanClaimAmount != 0 ? 'pc_submit_get' : 'pc_submit_get_un'"
                                    @click="clickClaim">
                                    Claim all
                                </div>

                            </div>
                        </div>

                        <div class="gay_line"></div>


                        <UserListView :listData="listData"></UserListView>
                    </div>


                    <div style="margin-bottom: 40px;visibility: hidden;">bee.com</div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import UserListView from "../view/UserListView.vue"
import Toast from "../message.js";
import { InviteInfoStore } from "../../util/InviteInfo.js";
export default {
    name: 'pcLayout',

    components: {
        UserListView
    },
    emits: ["claim"],
    props: {
        inviteUrl: "",
        inviteDispayUrl: "",
        normalOnceRewardAmount: 0,
        superOnceReferralAmount: 0,
        friendsAmount: 0,
        dividendYield: 0,
        xpCanClaimAmount: 0,
        inviteCode: "",
        listData: []
    },

    data() {
        return {
            // listData: [],
            // inviteCode: "",
            // inviteUrl: "",
            // inviteDispayUrl: "",
            // xpCanClaimAmount: "",
            isClaim: false,
            shareTitle: "Come to Bee.com to collect your " + this.dividendYield + "% XP rewards!",
            shareTxt: "Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!",
            facebook_url: "",
            twitter_url: "",
            email_url: "",
            in_url: "",
            tg_url: "",
        }
    },

    watch: {
        inviteUrl(value) {
            this.facebook_url = 'https://www.facebook.com/sharer.php?s=100&u=' + encodeURIComponent(this.inviteUrl) + "&title=" + this.shareTitle;
            this.twitter_url = 'http://twitter.com/share?url=' + encodeURIComponent(this.inviteUrl) + "&text=" + this.shareTitle;
            this.email_url = 'mailto:?subject=' + this.shareTitle + '&body=' + encodeURIComponent(this.inviteUrl);
            this.in_url = 'https://www.messenger.com/?' + encodeURIComponent(this.inviteUrl) + "&title=" + this.shareTitle;
            this.tg_url = 'https://telegram.me/share/url?url=' + encodeURIComponent(this.inviteUrl) + "&text=" + this.shareTxt + "&title=" + this.shareTitle;
        },

        xpCanClaimAmount(value) {
            this.isClaim = false;
        }



    },

    methods: {
        pcBack() {
            let view = document.getElementById("bee_nInvite");
            view.style.display = "none";
        },


        xcopyToClipboard(copyText) {
            navigator.clipboard.writeText(copyText).then(() => {
                Toast("copy successful", "success")
            });

        },
        copyToPCClipboard() {
            console.log("copyToClipboard")
            let copyText = "Come to Bee.com to collect your " + this.dividendYield + "% XP rewards!" + "Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!" + " " + this.inviteUrl;

            navigator.clipboard.writeText(copyText).then(() => {
                Toast("copy successful", "success")
            });

        },

        async clickClaim() {
            if (this.xpCanClaimAmount == 0) {
                return;
            }
            this.isClaim = true;
            let rDate = await InviteInfoStore.referralClaim();
            this.$emit("claim", 0);
        },
        share() {
            if (navigator.share) {
                navigator.share({
                    title: "Come to Bee.com to collect your " + this.dividendYield + "% XP rewards!",
                    text: "Stay ahead with the latest crypto trends and discover promising potential projects. Arm yourself with knowledge and insights in this bull run!",
                    url: this.inviteUrl
                }).then(() => {
                    console.log('Successful share');
                }).catch(error => {
                    console.log('Error sharing:', error);
                });
            } else {
                navigator.clipboard.writeText(this.inviteUrl).then(() => {
                    Toast("copy successful", "success")
                });
            }
        },



    },

    mounted() {
    },


}

</script>

<style scoped>
.bee_pc_invite_base_layout {
    flex-direction: column;
    display: flex;
    align-items: center;
    height: 110%;
}



.empty_share_div {
    width: 16px;
    height: 16px;
    background-image: url("../../assets/icon_share_img.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.empty_share_text {
    color: #FFF;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-left: 4px;
}

.empty_share_btn {
    display: flex;
    border-radius: 8px;
    background: #FFAB13;
    height: 45px;
    margin-left: 16px;
    margin-right: 16px;
    width: -webkit-fill-available;
    width: -moz-available;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.pc_header {
    background: #FFF;
    width: -webkit-fill-available;
    width: -moz-available;
    height: 55px;
    align-items: center;
    display: flex;
    justify-content: center;
    padding-left: 360px;
    padding-right: 360px;
}

.pc_back_layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    /* margin-top: 20px; */
    /* margin-bottom: 16px; */
    padding-top: 20px;
    padding-bottom: 20px;
    background: #fff;
    padding-left: 360px;
    padding-right: 360px;
    cursor: pointer;
}

.pc_content_layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    /* height: 800px; */
}

.img_ipx {
    width: 334px;
    height: 277px;
    margin-right: 16px;
    background-image: url("../../assets/icon_top_pc_i.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.invite_info_layout {
    display: flex;
    flex-direction: row;
    background-color: #FFFAEC;
    align-items: center;
    justify-content: space-between;
    /* background-image: url("../../assets/icon_pc_bg.png"); */
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    width: 100%;
    padding-left: 360px;
    padding-right: 360px;
}

.invite_info {
    color: #000;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    width: 384px
}

.pc_invite_content_layout {
    display: flex;
    flex-direction: column;
    padding-left: 360px;
    padding-right: 360px;
    background-color: #ffffff;
    /* overflow: hidden; */
    height: -webkit-fill-available;
    height: -moz-available;
    height: 500px;
}

.my_invite_xp_layout {
    display: flex;
    justify-content: space-between;
    width: -webkit-fill-available;
    width: -moz-available;
    margin-top: 4px;
    padding: 20px;
    align-items: center;
}

.pc_submit_get {
    color: #FFF;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 44px;
    border-radius: 8px;
    background: #FFAB13;
    height: 44px;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}


.submit_load {
    color: #FFF;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 44px;
    border-radius: 8px;
    background: #FFE7B3;
    height: 44px;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;
    align-items: center;
    width: 120px;
    display: flex;
}



.my_txt {
    color: #666;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.xp_txt {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.index_base_layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 12px;
}

.invite_layout {
    border-radius: 8px;
    background: #F8F8F8;
    display: flex;
    flex-direction: column;
}

.invite_left_txt {
    color: #666;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.xp_num_txt {
    color: #000;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.index_layout {
    width: 2px;
    height: 14px;
    background: #FFC04D;
    margin-right: 4px;
}

.index_title {
    color: #333;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.invite_right_layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: right;
    flex: 1;
}

.invite_right_txt_pc {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: right;
    white-space: nowrap;
    /* overflow: hidden; */
}

.icon_copy {
    width: 20px;
    height: 20px;
    background-image: url("../../assets/icon_copy.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin-left: 12px;
    cursor: pointer;
}

.ic_back {
    width: 22px;
    height: 22px;
    background-image: url("../../assets/ic_pc_back.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    cursor: pointer;
    margin-right: 8px;
}

.ic_back_right {
    width: 14px;
    height: 14px;
    background-image: url("../../assets/ic_r.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin-right: 4px;
    margin-left: 4px;
}

.line {
    display: flex;
    height: 1px;
    stroke-width: 1px;
    stroke: rgba(240, 238, 238, 0.93);
    background-color: rgba(240, 238, 238, 0.93);
    margin-left: 12px;
    margin-right: 12px;
    width: -webkit-fill-available;
    width: -moz-available;
}

.invite_item_layout {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

}

.logo_header {
    width: 1200px;
}

.logo_ic {
    width: 110px;
    height: 24px;
    background-image: url("../../assets/bee_icon_txt.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.back_home_txt {
    color: #999;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.back_invite_txt {
    color: #333;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.x_share {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/icon_x.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.tg_share {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/icon_tg.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.fb_share {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/icon_fb.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.more_share {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/icon_more.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.share_layout {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
}

.in_share {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/icon_in.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.email_share {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/icon_email.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.xp_num {
    color: #E44430;
    font-size: 24px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
}

.pc_submit_get_un {
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 44px;
    border-radius: 8px;
    background: rgba(255, 171, 19, 0.50);
    color: #fff;
    height: 44px;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.content_pc_layout {
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    height: -webkit-fill-available;
    height: -moz-available;
    height: 90%;
    overflow: auto;
    background-color: #fff;
}

.pc_invite_info_layout {
    display: flex;
    flex-direction: column;
    margin-right: 16px;
    padding-top: 12px;
    padding-bottom: 12px;
    margin-top: 12px;
}

.pc_red_xp_num {
    color: #F53019;
    font-size: 40px;
    font-style: normal;
    font-weight: 900;
    line-height: 60px;
}

.pc_invite_title_txt {
    color: #5D2E21;
    font-size: 44px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.pc_invite_info_txt {
    color: #5D2E21;
    font-size: 36px;
    font-style: normal;
    font-weight: 300;
    line-height: 60px;
    /* 150% */
}



.index_title {
    width: 80px;
    height: 8px;
    flex-shrink: 0;
}

.pc_info_line {
    width: 80px;
    height: 8px;
    flex-shrink: 0;
    background: #FFC727;
    margin-top: 14px;
    margin-bottom: 20px;
}



.rf_title_bonus {
    color: #5D2E21;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-top: 40px;
    text-align: center;
}

.pc_ic_logo {
    width: 60px;
    height: 60px;
    background-image: url("../../assets/ic_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.pc_item_for_xp {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 320px;
    height: 214px;
    border-radius: 16px;
    border: 1px solid #FFBE08;
    background: #FFFBF1;
    margin-left: 16px;
    margin-right: 16px;
}

.pc_xp_info_layout {
    display: flex;
    width: -webkit-fill-available;
    width: -moz-available;
    padding-left: 40px;
    padding-right: 40px;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 24px;
}

.pc_for_txt {
    color: #666;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-top: 12px;
    margin-bottom: 12px;
}

.pc_for_xp_txt {
    color: #FFA400;
    font-size: 44px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.pc_item_for_btn {
    width: 320px;
    height: 64px;
    flex-shrink: 0;
    border-radius: 16px;
    background: #FFAB13;
    color: #FFF;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 64px;
    margin-left: 16px;
    margin-right: 16px;
    cursor: pointer;
}

.rf_list_layout {
    border-radius: 12px;
    background: #FFFCF5;
    padding: 20px;
    width: 100%;
    margin-top: 30px;
}

.rf_reward_layout {
    display: flex;
    flex-direction: row;
    margin-top: 30px;
    align-items: center;
    justify-content: right;
}

.mini_pc_ic_logo {
    width: 26px;
    height: 26px;
    background-image: url("../../assets/ic_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin-left: 17px;
    margin-right: 1px;
}

.pc_total_txt {
    color: #666;
    font-size: 26px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.pc_total_num {
    color: #333;
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.gay_line {
    background-color: #ECECEC;
    display: flex;
    height: 1px;
    margin-top: 24px;
    margin-bottom: 24px;
}

.loading_logo {
    width: 18px;
    height: 18px;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/loading.gif");
    background-size: cover;
    background-repeat: no-repeat;
    /* animation: rotate 2s linear infinite; */
}

.css_margin_left {
    margin-left: 20px;
}



@media (max-width: 1920px) {
    .pc_invite_title_txt {
        font-size: 28px;
        font-weight: 500;
    }

    .pc_invite_info_txt {
        color: #5D2E21;
        font-size: 20px;
        font-style: normal;
        font-weight: 300;
        line-height: 18px;
        /* 150% */
    }

    .pc_red_xp_num {
        color: #F53019;
        font-size: 20px;
        font-style: normal;
        font-weight: 900;
        line-height: 60px;
    }

    .rf_title_bonus {
        color: #5D2E21;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-top: 40px;
        text-align: center;
    }

    .pc_for_txt {
        color: #666;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-top: 12px;
        margin-bottom: 12px;
    }

    .pc_header {
        padding-left: 360px;
        padding-right: 360px;
    }

    .invite_info_layout {
        padding-left: 360px;
        padding-right: 360px;
    }

    .pc_back_layout {
        padding-left: 360px;
        padding-right: 360px;
    }

    .pc_invite_content_layout {
        padding-left: 360px;
        padding-right: 360px;
    }

    .pc_ic_logo {
        width: 32px;
        height: 32px;
        background-image: url("../../assets/ic_logo.png");
        background-size: cover;
        background-repeat: no-repeat;
        box-sizing: border-box;
    }

    .pc_item_for_xp {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 320px;
        height: 164px;
        border-radius: 16px;
        border: 1px solid #FFBE08;
        background: #FFFBF1;
        margin-left: 16px;
        margin-right: 16px;
    }


    .pc_for_xp_txt {
        color: #FFA400;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .pc_item_for_btn {
        width: 320px;
        height: 42px;
        flex-shrink: 0;
        border-radius: 16px;
        background: #FFAB13;
        color: #FFF;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 42px;
        margin-left: 16px;
        margin-right: 16px;
        cursor: pointer;
    }

    .pc_total_txt {
        color: #666;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .mini_pc_ic_logo {
        width: 18px;
        height: 18px;
        background-image: url("../../assets/ic_logo.png");
        background-size: cover;
        background-repeat: no-repeat;
        box-sizing: border-box;
        margin-left: 17px;
        margin-right: 1px;
    }

    .pc_total_num {
        color: #333;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .pc_submit_get_un {
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 36px;
        border-radius: 8px;
        background: rgba(255, 171, 19, 0.50);
        color: #fff;
        height: 36px;
        padding-left: 10px;
        padding-right: 10px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .pc_submit_get {
        color: #FFF;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 36px;
        border-radius: 8px;
        background: #FFAB13;
        height: 36px;
        padding-left: 10px;
        padding-right: 10px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }


    .submit_load {
        color: #FFF;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 36px;
        border-radius: 8px;
        background: #FFE7B3;
        height: 36px;
        padding-left: 10px;
        padding-right: 10px;
        justify-content: center;
        align-items: center;
        width: 80px;
        display: flex;
    }

    .css_margin_left {
        margin-left: 20px;
    }

    .gay_line {
        background-color: #ECECEC;
        display: flex;
        height: 1px;
        margin-top: 14px;
        margin-bottom: 14px;
    }

    .pc_info_line {
        width: 80px;
        height: 4px;
        flex-shrink: 0;
        background: #FFC727;
        margin-top: 14px;
        margin-bottom: 12px;
    }

    .rf_reward_layout {
        display: flex;
        flex-direction: row;
        margin-top: 0px;
        align-items: center;
        justify-content: right;
    }

    .rf_list_layout {
        border-radius: 12px;
        background: #FFFCF5;
        padding: 20px;
        width: 100%;
        margin-top: 24px;
    }
}



@media (max-width: 1200px) {
    .pc_header {
        padding-left: 160px;
        padding-right: 160px;
    }

    .invite_info_layout {
        padding-left: 160px;
        padding-right: 160px;
    }

    .pc_back_layout {
        padding-left: 160px;
        padding-right: 160px;
    }

    .pc_invite_content_layout {
        padding-left: 160px;
        padding-right: 160px;
    }
}
</style>